import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class BOMService {
  getAllBOMs(idUser) {
    return api.get(UtilsUrl.productionURL() + "/bills-of-materials/" + idUser);
  }

  getAllProductsForBOM(idUser, onPurchase,service,stateBom) {
    return api.get(UtilsUrl.productionURL() + "/products/getAllProductsForBOM/" + idUser+
    "/" +
    onPurchase +
    "/" +
    service+
    "/" +
    stateBom);
  }

  getAllProductsOnSaleForBOM(idUser, onPurchase, onSale,service,stateBom) {
    return api.get(UtilsUrl.productionURL() + "/products/getAllProductsOnSaleForBOM/" + idUser+
    "/" +
    onPurchase +  "/" +
    onSale +
    "/" +
    service+
    "/" +
    stateBom);
  }

  getAllProductsWithBOMForPO(idUser, stateBom) {
    return api.get(UtilsUrl.productionURL() + "/products/getAllProductsWithBOMForPO/" + idUser+
    "/" +
    stateBom);
  }

  getBOMById(idBOM) {
    return api.get(UtilsUrl.productionURL() + "/bills-of-materials/getBOMById/" + idBOM);
  }

  addBOM(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/bills-of-materials/addBOM",
      modal
    );
  }
  updateBOM(modal) {
    return api.post(
      UtilsUrl.productionURL() + "/bills-of-materials/updateBOM",
      modal
    );
  }
}
export default new BOMService();
